const WidgetsImagePlaceholder = () => {
    return (
        <div className={'widgets-image-placeholder'} />
    );
};

export default WidgetsImagePlaceholder;
